module.exports = __webpack_public_path__ + "img/SignIn.332d2fd9.png";